import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { TaskItem, TaskItemFactory } from 'src/app/shared/models/task-item';
import { BaseEntityService } from 'src/app/shared/services/base-entity.service';
import { environment } from 'src/environments/environment';
// import Response = ZoningAPI.Response;
import PaginatedResponse = ZoningAPI.PaginatedResponse;
import ITaskItemDTO = ZoningAPI.ITaskItemDTO;
import ISearchProcessesPaginatedParams = ZoningAPI.ISearchProcessesPaginatedParams;

const API_ENDPOINT = environment.ZONAR_API_URL + '/task-items';

export interface ITaskItemsResponse {
    taskItems: TaskItem[];
    totalCount: number;
}

@Injectable({
    providedIn: 'root'
})
export class TaskItemService extends BaseEntityService<TaskItem> {
    constructor(private readonly http: HttpClient) {
        super(TaskItemFactory);
    }

    getTaskItems(
        state_env: string,
        processId: string,
        paginationParams?: ISearchProcessesPaginatedParams
    ): Observable<ITaskItemsResponse> {
        if (!state_env || !processId) {
            return of({ taskItems: [], totalCount: 0 });
        }

        const fromObject: any = {
            state_env,
            processId
        };

        if (paginationParams) {
            if (paginationParams.page !== undefined) {
                fromObject.page = String(paginationParams.page);
            }
            if (paginationParams.limit !== undefined) {
                fromObject.limit = String(paginationParams.limit);
            }
            if (paginationParams.getCount !== undefined) {
                fromObject.getCount = String(paginationParams.getCount);
            }
        }

        const params = new HttpParams({ fromObject });

        return this.http
            .get<PaginatedResponse<ITaskItemDTO[]>>(`${API_ENDPOINT}`, { params })
            .pipe(
                map(response => {
                    const taskItems = (response.data as ITaskItemDTO[]).map(dto => this.initEntity(dto));
                    return {
                        taskItems,
                        totalCount: response.rows || 0
                    };
                })
            );
    }
}
